<template>
  <div>
    <v-navigation-drawer class="d-md-none" app v-model="navDrawer" absolute temporary>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Heppi support
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ user }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>
        <template v-for="item in menu">
          <v-list-item v-if="item.routerLink" :key="item.name" :to="{ name: item.routerLink }">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group v-else-if="item.submenu" :key="item.name">
            <template v-slot:activator>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </template>
            <v-list-item v-for="subitem in item.submenu" :key="subitem.name" :to="{ name: subitem.routerLink }">
              <v-list-item-content>
                <v-list-item-title>{{ subitem.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item @click="logout()">
          <v-list-item-content>
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark fixed>
      <v-app-bar-nav-icon class="d-md-none" @click="navDrawer = !navDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Heppi Suporte</v-toolbar-title>
      <v-toolbar-items class="d-none d-md-block pl-5">
        <template v-for="item in menu">
          <v-btn text v-if="item.routerLink" :key="'menu' + item.name" exact :to="{ name: item.routerLink }">{{ item.name }}</v-btn>
          <v-menu offset-y v-else-if="item.submenu" :key="item.name">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">{{ item.name }} <v-icon>mdi-arrow-drop-down</v-icon></v-btn>
            </template>
            <v-list>
              <template v-for="subitem in item.submenu">
                <v-list-item v-if="!subitem.onlyBackoffice || !!isBackoffice" :key="subitem.name" exact :to="{ name: subitem.routerLink }">
                  <v-list-item-content>
                    <v-list-item-title>{{ subitem.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </template>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items class="d-none d-md-block">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">{{ user }}</v-btn>
          </template>
          <v-list>
            <v-list-item @click="logout()">
              <v-list-item-content>
                <v-list-item-title>Sair</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppHeader',
  data: () => ({
    navDrawer: false,
    generalMenu: [
      {
        name: 'Home',
        routerLink: 'home'
      },
      // {
      //   name: 'Calendário',
      //   routerLink: 'calendar'
      // },
      {
        name: 'Clientes',
        routerLink: 'customers'
      },
      {
        name: 'Turmas',
        routerLink: 'celebrations'
      },
      {
        name: 'Experiência',
        submenu: [
          {
            name: 'Usuários',
            routerLink: 'experienceUsers'
          },
          {
            name: 'Experiências',
            routerLink: 'experiences'
          }
        ]
      },
      {
        name: 'Apoio',
        submenu: [
          {
            name: 'Chamados',
            routerLink: 'technicalSupportPanel'
          },
          {
            name: 'Fornecedores',
            routerLink: 'providers'
          },
          {
            name: 'Consulta Fatura',
            routerLink: 'invoiceConsult'
          },
          {
            name: 'Enviar whatsapp',
            routerLink: 'automationSendWhatsapp'
          },
          {
            name: 'Enviar e-mail',
            routerLink: 'automationSendEmail'
          }
        ]
      }
    ],
    protectedMenu: [
      {
        name: 'Automações',
        submenu: [
          {
            name: 'Habilitar conta',
            routerLink: 'automationCreateAccount'
          },
          {
            name: 'Gerar financeiro',
            routerLink: 'automationGenerateFinancial'
          }
        ]
      },
      {
        name: 'Administração',
        submenu: [
          {
            name: 'Usuários',
            routerLink: 'users'
          }
        ]
      }
    ]
  }),
  computed: {
    ...mapGetters(['user', 'isSuperAdmin', 'isBackoffice']),
    menu () {
      let menu = [...this.generalMenu]
      if (this.isSuperAdmin) menu = [...menu, ...this.protectedMenu]
      return menu
    }
  },
  methods: {
    ...mapActions(['logout'])
  }
}
</script>
